import { render, staticRenderFns } from "./ChatPopup.vue?vue&type=template&id=3191e72b&scoped=true&"
import script from "./ChatPopup.vue?vue&type=script&lang=ts&"
export * from "./ChatPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChatPopup.vue?vue&type=style&index=0&id=3191e72b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3191e72b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VProgressCircular,VTextarea})
